import { clarityWebsite } from '../configs/tools/conversion-tracking/clarity-website';

export const clarity = {
  ...clarityWebsite,
  description: _TL_('Set up Clarity to see how customers interact with your site.'),
  externalLink: 'https://clarity.microsoft.com',
};
